import React from "react";

type SaasHeader = {
    title: string;
    region?: string;
    children?: React.ReactNode
};

export default function SaasHeader({ title, region, children }: SaasHeader) {
    return (
        <div className="paper app-name overflow-visible">
            <div className="image-container">
                <img src="/static/assets/dashboard/logo.png" />
            </div>
            <div className="text-container">
                <p className="app-name-heading">{title}</p>
                {region !== undefined && <p className="app-name-region">Region: {region}</p>}
            </div>
            {children}
        </div>
    );
}
